import { Resource } from 'i18next';

import en from './translations/en.json';
import de from './translations/de.json';
import es from './translations/es.json';
import { Language, TranslationKeys } from './translationModels';

const resources: Resource = {
  [Language.English]: { translation: en as TranslationKeys },
  [Language.German]: { translation: de as TranslationKeys },
  [Language.Spanish]: { translation: es as TranslationKeys },
};

export default resources;
